import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';

import { Copyright } from '../../Copyright';
import { ContactsStandard } from './Contacts';
import {
  CompanyInfoStyled,
  FooterStyled,
  IconStyled,
} from './FooterStandard.styles';

export const FooterStandard = ({ id, className }) => {
  const currentTheme = useTheme();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  return (
    <>
      <FooterStyled id={id ?? 'footer'} className={className ?? null}>
        {isDesktop && (
          <CompanyInfoStyled>
            <IconStyled iconI={currentTheme.customLogo.clogo} />
          </CompanyInfoStyled>
        )}
        <ContactsStandard />
      </FooterStyled>

      <Copyright />
    </>
  );
};

FooterStandard.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
};
